exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query_d0084f1{display:flex;flex-direction:row}.query_d0084f1>div{width:100%!important}.query_item_6196cf7{width:23%!important}.tableW_a8e5c7a{width:82%}", ""]);

// exports
exports.locals = {
	"query": "query_d0084f1",
	"query_item": "query_item_6196cf7",
	"tableW": "tableW_a8e5c7a"
};